import Component,{register} from '@services/component';
import {toggleClass} from '@services/dom';
import youtube from '@services/youtube';
import {subscribe} from '@services/events';
// import {disabled as disableWheel} from '@services/wheel';
import {isMobile,isTouch} from '@services/browser';

const isResponsive = isMobile||isTouch;

const awaitConsent = type=>(
  new Promise((resolve,_reject) => {
    global.CookieFirstEvents.on(type,resolve);
  })
)

export default register(
    class HeroSection extends Component{
        static selector = '.hero-section[data-yt-video]'

        getThumbnail(){
          const {ytVideo:videoId} = this.props;
          const {thumbnail=`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`} = this.props;
          return thumbnail;
        }

        async create(){
          if(isResponsive){
            this.createMobilePreview();
          }else{
            this.createDesktopPlayer();
          }
        }

        async createMobilePreview() {
          const thumbnail = document.createElement('img');
          thumbnail.src = this.getThumbnail();
          thumbnail.className = 'mobile-youtoube-thumbnail';
          this.el.insertBefore(thumbnail,this.el.firstChild);

          const fullscreenButton = document.createElement('button');
          fullscreenButton.className = 'video-button';
          fullscreenButton.innerHTML = '<span class="sr-only">abspielen</span>';
          fullscreenButton.addEventListener('click',this.toggleFullscreen.bind(this,true));
          this.el.querySelector('header').appendChild(fullscreenButton);
        }

        async createDesktopPlayer() {
          const {ytVideo:videoId} = this.props;

          const hasCustomThumbnail = Boolean(this.props.thumbnail);

          const thumbnail = document.createElement('img');
          thumbnail.src = this.getThumbnail();
          thumbnail.className = 'mobile-youtoube-thumbnail';
          this.el.insertBefore(thumbnail,this.el.firstChild);

          await awaitConsent('functional');

          const player = await youtube(
            {
              videoId,
              width:window.innerWidth,
              height:window.innerWidth / 16 * 9,
              playerVars:{
                controls:0,
                showinfo:0,
                showsearch:0,
                rel:0,
                fs:0,
                autohide:1,
                disablekb:1,
                iv_load_policy:3,
                loop:1,
                playlist:videoId,
                modestbranding:1,
                origin:location.protocol + '//' + location.host,
                enablejsapi:1,
              },
              events:{
                onReady(event){
                  event.target.mute();
                  if(!isResponsive){
                    if(hasCustomThumbnail){
                      event.target.seekTo(0);
                      event.target.pauseVideo();
                    }else{
                      event.target.playVideo();
                    }
                  }
                },
                onStateChange: event => {
                  if(event.data === window.YT.PlayerState.ENDED && this._isFullscreen){
                    this.toggleFullscreen(false);
                  }
                }
              }
            }
          );
          const fullscreenButton = document.createElement('button');
          fullscreenButton.className = 'video-button';
          fullscreenButton.innerHTML = '<span class="sr-only">abspielen</span>';
          fullscreenButton.addEventListener('click',this.toggleFullscreen.bind(this,true));

          const playButton = document.createElement('button');
          playButton.className = 'video-button';
          playButton.innerHTML = '<span class="sr-only">abspielen</span>';
          playButton.addEventListener('click',this.togglePlayPause.bind(this));

          // const closeButton = document.createElement('button');
          // closeButton.className = 'video-close-button';
          // closeButton.innerHTML = '<span class="sr-only">schließen</span>';
          // closeButton.addEventListener('click',this.toggleFullscreen.bind(this,false));

          if(!this.el){
            player.destroy();
          }else{
            this.player = player;
            toggleClass(this.player.element,'has-thumbnail', hasCustomThumbnail);
            this.el.insertBefore(player.element,this.el.firstChild);
            this.el.querySelector('header').appendChild(fullscreenButton);
            // player.element.appendChild(closeButton);
            player.element.appendChild(playButton);
            this.on(player.element,'click',this.togglePlayPause.bind(this));
          }
        }

        destroy(){
          this.player && this.player.destroy();
          this.unsubOffset && this.unsubOffset();
          super.destroy();
        }

        toggleFullscreen(force){
          if(isResponsive && force){
            const {ytVideo} = this.props;
            window.open(`https://youtube.com/watch?v=${ytVideo}`);
            return;
          }

          const {controller,element} = this.player;

          if(force===undefined){
            force = !this._isFullscreen;
          }else if(force === this._isFullscreen){
            return;
          }
          this._isFullscreen = force;
          toggleClass(element,'is-fullscreen',force);
          if(force){
            controller.unMute();
            controller.seekTo(0);
            controller.playVideo();
            toggleClass(element,'is-paused',false);
            this.closeOnNextScroll();
            // disableWheel(true);
          }else{
            controller.mute();
            // disableWheel(false);
          }
        }

        togglePlayPause(){
          if(!this._isFullscreen) return;
          const {controller,element} = this.player;
          if(controller.getPlayerState() === 1){
            controller.pauseVideo();
            toggleClass(element,'is-paused',true);
          }else{
            controller.playVideo();
            toggleClass(element,'is-paused',false);
          }
        }

        closeOnNextScroll(){
          this.unsubOffset = subscribe(this.el,'sections:offsetchange',(e)=>{
            if(Math.abs(e.detail.offset) > .4){
              this.unsubOffset();
              this.unsubOffset = null;

              this.toggleFullscreen(false);
            }
          })
        }
    }
)